import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'
import { Observable, Subscription, of } from 'rxjs'
import { debounceTime, map, mergeMap, startWith, tap } from 'rxjs/operators'
import { Client } from '../../shared/client/client'
import { ClientService } from '../../shared/client/client.service'

@Component({
  selector: 'app-account-selector',
  templateUrl: './account-selector.component.html',
  styleUrls: ['./account-selector.component.scss']
})
export class AccountSelectorComponent implements OnInit, OnDestroy {

  prevSearch: string = ""
  clients: Array<Client>
  selectedClient: Client
  filteredClients: Observable<Array<Client>>
  filterControl: UntypedFormControl
  subClient: Subscription
  loadingClients = false

  constructor(private clientService: ClientService) {
  }

  ngOnInit() {
    this.clients = new Array<Client>()
    this.filterControl = new UntypedFormControl()
    this.subClient = this.clientService.getCurrentClient().subscribe(
      client => {
        this.selectedClient = client
        this.filterControl.setValue(client)

      },
      err => console.log(err)
    )

    this.filteredClients = this.filterControl.valueChanges.pipe(
      startWith<string | Client>(''),
      debounceTime(500),
      map(value => typeof value === 'string' ? value : this.displayFn(value)),
      mergeMap(val => {
        return this.updateClientFilter(val)
      },
      ))

    this.getSelectedClient() ?
      this.clientService.selectClient(this.getSelectedClient()) :
      this.clientService.selectClient(null)
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  displaySelected() {
    if (typeof this.filterControl.value !== 'object') {
      this.filterControl.setValue(this.selectedClient)
      localStorage.setItem('client', JSON.stringify(this.selectedClient))
    }
  }

  clearFilter() {
    this.filterControl.setValue("")
    localStorage.removeItem('client')
  }

  updateClientFilter(val: string): Observable<Client[]> {
    let ret: Observable<Client[]>
    if (!this.selectedClient || !val.includes(this.displayFn(this.selectedClient) || '') && (this.clients == null || this.clients.length === 100 || this.clients.length === 0 || !val.includes(this.prevSearch))) {
      this.loadingClients = true
      ret = this.clientService.getClients(val).pipe(
        tap(clients => {
          this.clients = clients
          this.loadingClients = false
        })
      )
    } else {
      ret = of(this.clients.filter(client => {
        return this.displayFn(client).toLowerCase().indexOf(val.toLowerCase()) !== -1
      }))
    }
    this.prevSearch = val
    return ret
  }

  updateClient($event: MatAutocompleteSelectedEvent) {
    this.clientService.selectClient($event.option.value)
    localStorage.setItem('client', JSON.stringify(this.selectedClient))
  }

  displayFn(client?: Client): string | undefined {
    return client ? (client.site == null ? '' : client.site.numero + ': ') + client.code_client + "/" + client.code_service + " - " + client.raison_sociale : undefined
  }

  getSelectedClient(): Client {
    return localStorage.getItem('client') ? JSON.parse(localStorage.getItem('client')) : null
  }
}
